/* eslint-disable no-console */
import { Component, EventEmitter, Inject, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { IbCheckinApisService } from '../../services/ib-checkin-apis.service';
import { ApisForm, ApisFormProps } from 'commercial-management--digital--web-components-design--library';
import { Subscription } from 'rxjs';
import { IbCheckinApisFormService } from './services/ib-checkin-apis-form.service';
import { ApisPassengerState } from '@src/app/core/constants/ib-checkin-apis-constants';
import { ApisPassenger, EmitPassengerStatus, FormDataChecksAllPassengers } from '@src/app/core/models/ib-checkin-apis/ib-checkin-apis.model';
import { FormDataApis } from 'commercial-management--digital--web-components-design--library/dist/components/layout/ApisForm/ApisForm.model';
import { cloneDeep } from 'lodash-es';
import { NavigationEnd, Router } from '@angular/router';

@Component({
    selector: 'ib-checkin-form-apis',
    template: `
        <div id="react-components">
            <ng-react [component]="ApisForm" [props]="props"></ng-react>
        </div>
    `
})
export class IbCheckinFormApisComponent implements OnInit, OnDestroy {
    private subscription: Subscription | undefined;
    private routerSubscription: Subscription;
    protected ApisForm = ApisForm;
    props: ApisFormProps;

    @Input() passenger: ApisPassenger;
    @Input() isMultiPassengers: boolean;
    @Input() index: number;
    @Output() passengerStatusChange = new EventEmitter<{ status: ApisPassengerState; id: number; index: number }>();
    @Output() updateOverlayStatus = new EventEmitter<ApisPassengerState>();
    @Output() showModalCheckinNotAvailable = new EventEmitter<EmitPassengerStatus>();

    constructor (private ApisService: IbCheckinApisService, private ApisFormService: IbCheckinApisFormService, private router: Router) {}

    async ngOnInit () {
        this.props = this.ApisFormService.getApisFormProps(this.passenger, this.onSubmitApisForm, this.isMultiPassengers);
        this.initSubscriptions();
    }

    initSubscriptions () {
        const getData = (formData: FormDataChecksAllPassengers) => {
            const data = this.ApisFormService.transformerCheckAllPassengers(formData, this.props);
            this.props = cloneDeep(data);
        };
        const getRouterEvent = (event) => {
            if (event instanceof NavigationEnd) {
                this.unsubscribe();
                this.initSubscriptions();
            }
        };

        this.subscription = this.ApisService.checkAllPassengers$.subscribe(getData);
        this.routerSubscription = this.router.events.subscribe(getRouterEvent);
    }

    unsubscribe () {
        if (this.subscription) {
            this.subscription.unsubscribe();
            this.ApisService.resetCheckAllPassengersData();
        }
    }

    isBlockForm (status: ApisPassengerState) {
        const validStatusBlockForm = [ApisPassengerState.COMPLETED, ApisPassengerState.DOCUMENTATION];
        const isBlockForm = validStatusBlockForm.includes(status);
        this.props = {
            ...this.props,
            isBlockForm: isBlockForm
        };
    }

    onSubmitApisForm = async (formApis: FormDataApis) => {
        const fullName = `${formApis.personalData.name} ${formApis.personalData.surname}`.trim();
        const emitPassengerStatus: EmitPassengerStatus = {
            status: ApisPassengerState.COMPLETED,
            id: Number(this.props.id),
            index: this.index,
            fullName: fullName
        };

        try {
            this.updateOverlayStatus.emit(ApisPassengerState.PENDING);
            await this.ApisService.updateApisInfo(formApis, this.props.id);
            this.updateOverlayStatus.emit(ApisPassengerState.COMPLETED);
        } catch (error: any) {
            emitPassengerStatus.status = ApisPassengerState.PENDING;
            if (error.isEstaConstraints || error.isEesConstraints || error.isEtiasConstraints || error.isSeeAgent) {
                const existReason = error.isEesConstraints || error.isEtiasConstraints;
                if (existReason) {
                    emitPassengerStatus.showMessage = true;
                    emitPassengerStatus.message = error.message;
                }
                emitPassengerStatus.status = ApisPassengerState.DOCUMENTATION;
                // this.showModalCheckinNotAvailable.emit(emitPassengerStatus);
            }
            throw error;
        } finally {
            const element = document.getElementById('passenger' + emitPassengerStatus.id);
            this.isBlockForm(emitPassengerStatus.status);
            this.passengerStatusChange.emit(emitPassengerStatus);
            if( emitPassengerStatus.status === ApisPassengerState.DOCUMENTATION ) this.showModalCheckinNotAvailable.emit(emitPassengerStatus);
            this.updateOverlayStatus.emit(ApisPassengerState.CLOSE);
            if (element) element.scrollIntoView({ behavior: 'smooth' });
        }
    };

    ngOnDestroy () {
        if (this.routerSubscription) this.routerSubscription.unsubscribe();
    }
}
